/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sourcemanual1Inputs */

const en_sourcemanual1 = /** @type {(inputs: Sourcemanual1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manual`)
};

const pt_sourcemanual1 = /** @type {(inputs: Sourcemanual1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`manual`)
};

/**
* | output |
* | --- |
* | "manual" |
*
* @param {Sourcemanual1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const sourcemanual1 = /** @type {((inputs?: Sourcemanual1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sourcemanual1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sourcemanual1(inputs)
	return pt_sourcemanual1(inputs)
});
export { sourcemanual1 as "sourceManual" }